import { Pipe, PipeTransform } from '@angular/core';
import { RelativeDateService } from './relative-date.service';

@Pipe({
    name: 'fiRelativeDate',
    standalone: false,
})
export class RelativeDatePipe implements PipeTransform {
    constructor(private relativeDateService: RelativeDateService) {}
    transform(date, now): string {
        return this.relativeDateService.getRelativeDate(date, now);
    }
}
